import LoginForm from 'Forms/Auth/LoginForm';
import React from 'react';

const Login = () => (
  <div className="flex h-screen items-center justify-center">
    <div className="mx-auto w-full max-w-sm px-4">
      <div className="flex justify-center">
        <img className="max-w-full" src="/icon/logo-dark.png/1" alt="Logo" />
      </div>

      <div className="mt-6">
        <LoginForm className="block max-w-full" />
      </div>
    </div>
  </div>
);

export default Login;
